export default {
  state: {
    // 被激活的带单的链接地址 - 当前已点击的菜单
    activePath: '',
    // 已点击的tab-list数据，如果无缓存，赋默认值 - 默认只有一个首页
    tabList: []
  },
  getters: {
    getActivePath: (state) => {
      return state.activePath
    },
    getTabList: (state) => {
      return state.tabList
    }
  },
  mutations: {
    //清除标签
    clear_tags(state) {
      state.tabList = []
      localStorage.removeItem('menuTabList')
    },
    //登录或刷新加载标签
    add_homeTag(state) {
      if (!localStorage.getItem('menu')) {
        return
      }
      if (localStorage.getItem('menuTabList')) {
        const tabList = JSON.parse(localStorage.getItem('menuTabList'))
        tabList.forEach(item => {
          state.tabList.push(item)
        })
        state.activePath = localStorage.getItem('activePath')
      } else {
        const menu = JSON.parse(localStorage.getItem('menu'))
        menu.forEach(item => {
          // 添加首页tag 标签
          if (item.menuName === '首页') {
            state.activePath = item.path
            state.tabList.push({
              path: item.path,
              name: item.path,
              label: item.menuName
            })
          }
        })
        localStorage.setItem('menuTabList', JSON.stringify(state.tabList))
        localStorage.setItem('activePath', state.activePath)
      }
    },
    // 添加tags
    add_tags(state, data) {
      state.tabList.push(data)
      localStorage.removeItem('menuTabList')
      localStorage.setItem('menuTabList', JSON.stringify(state.tabList))
    },
    // 删除tags
    delete_tags(state, path) {
      let index = 0
      for (const tab of state.tabList) {
        if (tab.name === path) {
          break
        }
        index++
      }
      state.tabList.splice(index, 1)//删除tabList里面下标为Index的一个数
      localStorage.removeItem('menuTabList')
      localStorage.setItem('menuTabList', JSON.stringify(state.tabList))
    },
    // 设置当前激活的tab
    set_ActivePath(state, index) {
      state.activePath = index
      localStorage.setItem('activePath', index)
    }
  },
  actions: {}
}

